// components/Nav.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import StoreRequestPopup from './StoreRequestPopup';
import logo from './assets/logo.png';
import './Nav.css';

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle hash link navigation
  const handleHashLink = (e, sectionId) => {
    e.preventDefault();
    closeMobileMenu();

    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll to section
      setTimeout(() => {
        scrollToSection(sectionId);
      }, 100);
    } else {
      // If on home page, scroll to section directly
      scrollToSection(sectionId);
    }
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80; // Adjust based on your navbar height
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleGetStartedClick = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
    closeMobileMenu();
  };

  const handleDemoClick = (e) => {
    e.preventDefault();
    window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
    closeMobileMenu();
  };

  const handleDemoClickSite = () => {
        window.open('https://demo-site.creativepulse.pk/', '_blank', 'noopener,noreferrer');
    };

  // Navigation items with section IDs
  const navItems = [
    { name: 'What We Offer', sectionId: 'setup-store' },
    { name: 'Included', sectionId: 'store-launch-kit' },
    { name: 'Pricing', sectionId: 'packages' },
    { name: 'Demo', sectionId: 'before-start' }
  ];

  return (
    <>
      <nav className={`nav ${isScrolled ? 'nav-scrolled' : ''}`}>
        <div className="nav-container">

          {/* Logo */}
          <Link to="/" className="nav-logo" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>

          {/* Mobile Menu Button */}
          <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Navigation Menu */}
          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                {item.sectionId === 'demo' ? (
                  <a
                    href={item.externalUrl || 'https://demo-site.creativepulse.pk/'}
                    className="nav-link"
                    onClick={handleDemoClick}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.name}
                  </a>
                ) : (
                  <a
                    href={`#${item.sectionId}`}
                    className={`nav-link ${location.pathname === '/' && location.hash === `#${item.sectionId}` ? 'active' : ''}`}
                    onClick={(e) => handleHashLink(e, item.sectionId)}
                  >
                    {item.name}
                  </a>
                )}
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <div className="nav-button">
{/*             
            <a href="#" className="btn-get-started" onClick={handleGetStartedClick}>
              Get Started
            </a>
*/}            
            <a href="#" className="btn-get-started" onClick={handleDemoClickSite}>
              View Demo Store
            </a>
          </div>

        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="mobile-backdrop" onClick={closeMobileMenu}></div>
      )}

      <StoreRequestPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
    </>
  );
};

export default Nav;